import { Box, Fade, Grow } from "@mui/material";
import { ReactNode } from "react";
import { useInView } from "./useInView";

type FadeInWhenVisibleProps = {
  children: ReactNode;
  /** 'fade' | 'grow' */
  variant?: "fade" | "grow";
  /** Длительность в мс */
  timeout?: number;
  /** Смещение зоны срабатывания (rootMargin) */
  rootMargin?: string;
};

export default function FadeInWhenVisible({
  children,
  variant = "fade",
  timeout = 500,
  rootMargin = "0px 0px -60px 0px",
}: FadeInWhenVisibleProps) {
  const [ref, isInView] = useInView({ rootMargin, threshold: 0.1 });

  return (
    <Box ref={ref} sx={{ minHeight: 1 }}>
      {variant === "grow" ? (
        <Grow in={isInView} timeout={timeout} mountOnEnter>
          <Box sx={{ display: "block", width: "100%" }}>{children}</Box>
        </Grow>
      ) : (
        <Fade in={isInView} timeout={timeout} mountOnEnter>
          <Box>{children}</Box>
        </Fade>
      )}
    </Box>
  );
}
